export default __webpack_public_path__ + "static/media/Komiku_Good_Fellow.62c8fff5.mp3";